import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

/**
 * Hook de sesión. Supabase ya persiste la sesión en localStorage y
 * refresca el token automáticamente, así que el usuario sólo necesita
 * iniciar sesión una vez (mientras no cierre sesión manualmente o
 * el refresh token expire por inactividad prolongada).
 */
export const useAuth = () => {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1) Suscribirse PRIMERO para no perder eventos
    const { data: sub } = supabase.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession);
      setLoading(false);
    });

    // 2) Recuperar la sesión existente desde localStorage
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });

    return () => sub.subscription.unsubscribe();
  }, []);

  return { session, user: session?.user ?? null, loading };
};
